import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import infoIcon from "../assets/images/infobtnblue.svg";
import PlusPlaceholder from "../assets/images/PlusImage.png";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import { apiCall } from "../services/AxiosService";
import { commonservices } from "../services/CommonServices";
import { useDispatch } from "react-redux";
import { RoleGetList } from "../services/ReduxTookit/Slice/RoleRedux";
import {
  SubscribersContactGetByPrimaryKey,
  SubscribersContactResendVerificationMail,
  SubscribersContactSave,
} from "../services/ReduxTookit/Slice/SubscribersContactRedux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
const ContactModal = (props) => {
  const DevRoute = window.location.href.includes(
    `${process.env.REACT_APP_DEV}`
  );

  const [Loading, setLoading] = useState(false);
  const [ContactDetailLoading, setContactDetailLoading] = useState(false);
  const ProfileImgref = useRef();
  const [file, setFile] = useState();
  const [roleType, setRoleType] = useState(null);
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    subscriberscontactid: 0,
    firstname: "",
    lastname: "",
    email: "",
    contactno: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    photofile: "",
    roleid: "",
    developerroleid: DevRoute ? 7 : "",
    errors: {
      subscriberscontactid: "",
      firstname: "",
      lastname: "",
      email: "",
      contactno: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zipcode: "",
      photofile: "",
      roleid: "",
      ValidationRules: [
        {
          FieldName: "firstname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "lastname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "email",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "email",
          ValidationType: "email",
          ValidationMessage: "Invalid email format",
        },
        {
          FieldName: "contactno",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "roleid",
          ValidationType: DevRoute ? "" : "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const ProfileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== "image/png" && file.type !== "image/jpeg") {
      return toast.error("Only PNG and JPEG images are allowed.");
    }
    const maxSize = 1 * 1024 * 1024;
    if (file.size > maxSize) {
      return toast.error("File size must not exceed 1 MB.");
    }
    setInput({
      ...input,
      photofile: file,
    });
    setFile(URL.createObjectURL(file));
  };

  async function getContactDetail() {
    setContactDetailLoading(true);
    dispatch(
      SubscribersContactGetByPrimaryKey(
        props?.selectedcontact?.subscriberscontactid
      )
    )?.then((response) => {
      setContactDetailLoading(false);
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data) {
          setInput({
            ...input,
            subscriberscontactid: response?.payload?.data?.data
              ?.subscriberscontactid
              ? response?.payload?.data?.data?.subscriberscontactid
              : "",
            firstname: response?.payload?.data?.data?.firstname
              ? response?.payload?.data?.data?.firstname
              : "",
            lastname: response?.payload?.data?.data?.lastname
              ? response?.payload?.data?.data?.lastname
              : "",
            email: response?.payload?.data?.data?.email
              ? response?.payload?.data?.data?.email
              : "",
            contactno: response?.payload?.data?.data?.contactno
              ? response?.payload?.data?.data?.contactno
              : "",
            address: response?.payload?.data?.data?.address
              ? response?.payload?.data?.data?.address
              : "",
            city: response?.payload?.data?.data?.city
              ? response?.payload?.data?.data?.city
              : "",
            state: response?.payload?.data?.data?.state
              ? response?.payload?.data?.data?.state
              : "",
            country: response?.payload?.data?.data?.country
              ? response?.payload?.data?.data?.country
              : "",
            zipcode: response?.payload?.data?.data?.zipcode
              ? response?.payload?.data?.data?.zipcode
              : "",
            photofile: response?.payload?.data?.data?.photourl
              ? response?.payload?.data?.data?.photourl
              : "",
            roleid: response?.payload?.data?.data?.roleid
              ? response?.payload?.data?.data?.roleid
              : "",
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  const getRoleByType = async () => {
    dispatch(RoleGetList())?.then((res) => {
      if (res?.payload?.isValidate) {
        setRoleType(res?.payload?.data?.data);
      }
      if (!res?.payload?.isValidate) {
        setRoleType(null);
      }
    });
  };
  useEffect(() => {
    getRoleByType();
  }, []);
  useEffect(() => {
    if (props?.type === "Update") {
      getContactDetail();
    }
  }, [props?.type]);
  const fnInputChange = (value, tag) => {
    setInput({
      ...input,
      [tag]: value,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(input);
    setInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let body = {
        subscriberscontactid: input?.subscriberscontactid,
        firstname: input?.firstname?.trim(),
        lastname: input?.lastname?.trim(),
        email: input?.email?.trim(),
        contactno: input?.contactno?.trim(),
        address: input?.address?.trim(),
        city: input?.city?.trim(),
        state: input?.state?.trim(),
        country: input?.country?.trim(),
        zipcode: input?.zipcode?.trim(),
        photofile: input?.photofile,
        roleid: input?.roleid,
        developerroleid: input?.developerroleid,
      };
      dispatch(SubscribersContactSave(body))?.then((response) => {
        setLoading(false);
        if (response?.payload?.isValidate) {
          props.bindlist();
          props.onHide();
        }

        if (!response?.payload?.isValidate) {
        }
      });
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      {Loading && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.type} Contact
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      >
        <Modal.Body>
          {ContactDetailLoading ? (
            <div className="my-5 text-center">
              <Spinner className="ms-1" animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <Row>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">
                      First Name<span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={67}
                        placeholder="first name"
                        className="common-input"
                        value={input.firstname}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "firstname")
                        }
                        isInvalid={input?.errors?.firstname}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                      {input.errors.firstname && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.firstname}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">
                      Last Name<span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={67}
                        placeholder="last name"
                        className="common-input"
                        value={input.lastname}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "lastname")
                        }
                        isInvalid={input?.errors?.lastname}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                      {input.errors.lastname && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.lastname}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label w-100">
                      <div className="d-flex justify-content-between align-items-center">
                        <p>
                          Email<span className="ms-1 red-color-text">*</span>
                        </p>
                      </div>
                    </Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        disabled={props?.type === "Update"}
                        maxLength={167}
                        placeholder="email"
                        className="common-input"
                        value={input.email}
                        onChange={(e) => fnInputChange(e.target.value, "email")}
                        isInvalid={input?.errors?.email}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                      {input.errors.email && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.email}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  {DevRoute ? (
                    <Form.Group className="form-group mb-3">
                      <Form.Label className="login-label">
                        Devloper Role
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          disabled
                          className="common-select contact-dropdown-size m-0"
                          value={input.developerroleid}
                        >
                          <option value={7}>Contact</option>
                        </Form.Select>
                      </div>
                    </Form.Group>
                  ) : (
                    <Form.Group className="form-group mb-3">
                      <Form.Label className="login-label">
                        Workflow Role
                        <span className="ms-1 red-color-text">*</span>
                      </Form.Label>
                      <div className="position-relative">
                        <Form.Select
                          className="common-select contact-dropdown-size m-0"
                          value={input.roleid}
                          onChange={(e) => {
                            fnInputChange(
                              e?.target?.value
                                ? parseInt(e?.target?.value)
                                : "",
                              "roleid"
                            );
                          }}
                          isInvalid={input?.errors?.roleid}
                        >
                          <option value="">Select Role</option>
                          {roleType?.dataList1?.map((item) => {
                            return (
                              <option value={item?.roleid}>
                                {item?.rolename}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {input.errors.roleid && (
                          <Form.Control.Feedback type="invalid">
                            <span className="error-message-icon">
                              <img
                                src={infoIcon}
                                alt="infoIcon"
                                title={input.errors.roleid}
                              />
                            </span>
                          </Form.Control.Feedback>
                        )}
                      </div>
                    </Form.Group>
                  )}
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">
                      Contact No.<span className="ms-1 red-color-text">*</span>
                    </Form.Label>
                    <div className="position-relative">
                      {/* <Form.Control
                        type="text"
                        maxLength={13}
                        placeholder="contact no."
                        className="common-input"
                        value={input.contactno}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "contactno")
                        }
                        isInvalid={input?.errors?.contactno}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      /> */}
                      <PhoneInput
                        id="mobileNum"
                        international
                        defaultCountry="US"
                        placeholder="Enter phone number"
                        value={input.contactno}
                        maxLength={18}
                        onChange={(value) => fnInputChange(value, "contactno")}
                        inputProps={{
                          name: "phone",
                          required: true,
                        }}
                        className={
                          input.errors.contactno
                            ? "country-selection error-border"
                            : "country-selection"
                        }
                        title={input.errors.contactno}
                      />
                      {input.errors.contactno && (
                        <Form.Control.Feedback type="invalid">
                          <span className="error-message-icon">
                            <img
                              src={infoIcon}
                              alt="infoIcon"
                              title={input.errors.contactno}
                            />
                          </span>
                        </Form.Control.Feedback>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">Address</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={267}
                        placeholder="address"
                        className="common-input"
                        value={input.address}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "address")
                        }
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">City</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={67}
                        placeholder="city"
                        className="common-input"
                        value={input.city}
                        onChange={(e) => fnInputChange(e.target.value, "city")}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">State</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={67}
                        placeholder="state"
                        className="common-input"
                        value={input.state}
                        onChange={(e) => fnInputChange(e.target.value, "state")}
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">Country</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={67}
                        placeholder="country"
                        className="common-input"
                        value={input.country}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "country")
                        }
                        onKeyPress={(event) => {
                          if (event.key === "Enter") {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="form-group mb-3">
                    <Form.Label className="login-label">Zip Code</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type="text"
                        maxLength={13}
                        placeholder="zip code"
                        className="common-input"
                        value={input.zipcode}
                        onChange={(e) =>
                          fnInputChange(e.target.value, "zipcode")
                        }
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Form.Group className="mb-3" controlId="formProfilePic">
                  <Form.Label className="common-label">
                    Profile Picture
                  </Form.Label>
                  <div className="position-relative">
                    <div
                      className={`file-input ${
                        input.errors.photofile && "error-border-line"
                      }`}
                    >
                      <input
                        type="file"
                        className="form-control d-none"
                        id="profileImg"
                        ref={ProfileImgref}
                        accept="image/png, image/jpeg"
                        onChange={ProfileChange}
                      />
                      <label className="file-input__label" htmlFor="profileImg">
                        {file ? (
                          <img
                            height={38}
                            src={file}
                            alt={input.photofile ? file : PlusPlaceholder}
                          />
                        ) : (
                          <img
                            height={38}
                            src={input.photofile || PlusPlaceholder}
                            alt={input.photofile ? file : PlusPlaceholder}
                          />
                        )}
                      </label>
                    </div>
                  </div>
                </Form.Group>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="grey-btn w-auto" onClick={props.onHide}>
            Close
          </button>
          <button disabled={Loading} className="blue-btn w-auto" type="submit">
            {Loading ? (
              // <>
              //   <span>Loading</span>{" "}
              //   <Spinner
              //     className="ms-1"
              //     animation="border"
              //     role="status"
              //     size="sm"
              //   >
              //     <span className="visually-hidden">Loading...</span>
              //   </Spinner>
              // </>
              <SubmitLoading />
            ) : (
              "Submit"
            )}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ContactModal;
